import _ from 'lodash';
import { API_GET_LIST_PROFFIT_SEARCH_SHARE_RECEIVE_HEADER_SUCCESS, UPDATE_PROFFIT_SEARCH_SHARE_RECEIVE_HEADER_READ_AT, } from '../actions/ProffitSearchReceiveHeaderAction';
import { getCurrentDatetimeString } from '../helpers/common';
const INITIAL_STATE = {
    list: null,
    readIds: [],
    unreadCount: 0,
};
// eslint-disable-next-line default-param-last
export default (state = INITIAL_STATE, { payload, type }) => {
    switch (type) {
        /**
         * APIから値を取得した際、既読対象のID配列（readIds）と一致するデータは既読扱いにする
         * （ヘッダーのデータ読み込みが完了する前に、受領スライドの読み込みが完了してしまうための対応）
         */
        case API_GET_LIST_PROFFIT_SEARCH_SHARE_RECEIVE_HEADER_SUCCESS: {
            const { readIds } = state;
            let unreadCount = 0;
            const list = payload.list.map((v) => {
                if (!readIds.includes(v.id) || v.readAt) {
                    return v;
                }
                unreadCount += 1;
                return Object.assign(Object.assign({}, v), { readAt: getCurrentDatetimeString() });
            });
            return Object.assign(Object.assign({}, state), { list, unreadCount: payload.unreadCount - unreadCount });
        }
        // 強制的に既読として扱うidを保存する
        case UPDATE_PROFFIT_SEARCH_SHARE_RECEIVE_HEADER_READ_AT: {
            const { id } = payload;
            return Object.assign(Object.assign({}, state), { readIds: _.uniq(state.readIds.concat(id)) });
        }
        default: {
            return state;
        }
    }
};
